class Widget {
  constructor(widgetContainer, widgetButton, widgetClass) {
    this.widgetContainer = document.querySelector(widgetContainer);
    this.widgetButton = document.querySelectorAll(widgetButton);
    this.widgetClass = widgetClass;
  }

  toggleWidget() {
    if (this.widgetButton) {
      this.widgetButton.forEach((el) => {

        el.addEventListener('click', () => {

          this.widgetContainer.classList.toggle(this.widgetClass);
          this.widgetContainer.classList.toggle('animated');
          this.widgetContainer.classList.toggle('fadeIn');
        })
      })
    }
  }
}

export default Widget;


// WEBPACK FOOTER //
// ./scripts/modules/widget.js